/* ============================================================
   KHAVIYAR — post add-to-cart offer  (10 Sep 2026, v2: size pills)

   Upsize the tin · pair with the other caviar · spoon and opener.

   RULES
   - Fires on EVERY eligible add to cart or buy now. No session cap.
   - Modal in the browser top layer, above every drawer and dialog. The page
     is locked until the shopper chooses or dismisses. Dismiss = X, "No
     thanks", Escape, or a tap on the dark backdrop.
   - Sizes are chosen inside the offer. Upsize lists every in-stock size
     LARGER than the tin added; pair lists every in-stock size of the other
     caviar that is the SAME size or larger. A smaller tin is never offered.
     Defaults: the next size up, and the pair size with the most units in
     stock (so stock depletes evenly).
   - Prices are delivered by Shopify discounts, never by this script:
       UPSIZE10  10% off the 50g and 100g tins
       PAIR10    10% off caviar, needs 2 or more tins in the cart
       BOTH20    20% off caviar, needs $269.90 or more of caviar (an upsized
                 tin plus a pair)
       automatic: spoon and tin opener for $19.95 the pair
     Every condition is checked again at checkout, so removing an added tin
     removes its saving. Percentage savings are floored to the cent, exactly
     as Shopify does, so the popup matches the cart to the cent.
   - Stock: Liquid config at render time, re-checked live from
     /products/{handle}.js before anything is offered. Unavailable sizes are
     never listed.

   TESTING: add ?kh_upsell=test to the URL to force the popup on any add.
   ============================================================ */
(function () {
  'use strict';

  if (window.__khUpsell) return;
  window.__khUpsell = true;

  var CFG = window.KH_UPSELL;
  if (!CFG || !CFG.products || !CFG.products.length) return;

  var FORCE = /[?&]kh_upsell=test(&|$)/.test(window.location.search);
  var openNow = null;
  var BYPASS = false;

  /* ---------- scroll lock (holds iOS Safari) ---------- */
  var SCROLL_Y = 0;
  function lockScroll() {
    SCROLL_Y = window.pageYOffset || document.documentElement.scrollTop || 0;
    var b = document.body;
    b.style.position = 'fixed';
    b.style.top = -SCROLL_Y + 'px';
    b.style.left = '0';
    b.style.right = '0';
    b.style.width = '100%';
    document.documentElement.style.overflow = 'hidden';
  }
  function unlockScroll() {
    var b = document.body;
    b.style.position = '';
    b.style.top = '';
    b.style.left = '';
    b.style.right = '';
    b.style.width = '';
    document.documentElement.style.overflow = '';
    window.scrollTo(0, SCROLL_Y);
  }

  /* ---------- top-layer guard: nothing else may show while we are up ---------- */
  var GUARD = { on: false, orig: null, obs: null };
  function shutOthers() {
    if (!openNow) return;
    var ds = document.querySelectorAll('dialog[open]');
    var displaced = false;
    for (var i = 0; i < ds.length; i++) {
      if (ds[i] !== openNow) {
        try { ds[i].close(); } catch (e) {}
        displaced = true;
      }
    }
    if (displaced && openNow && openNow.open) {
      try { openNow.close(); openNow.showModal(); } catch (e) {}
    }
  }
  function guardEngage() {
    if (GUARD.on) return;
    GUARD.on = true;
    document.documentElement.classList.add('kh-up-lock');
    if (window.HTMLDialogElement && HTMLDialogElement.prototype.showModal) {
      GUARD.orig = HTMLDialogElement.prototype.showModal;
      HTMLDialogElement.prototype.showModal = function () {
        if (openNow && this !== openNow) {
          try { this.close(); } catch (e) {}
          return;
        }
        return GUARD.orig.apply(this, arguments);
      };
    }
    try {
      GUARD.obs = new MutationObserver(shutOthers);
      GUARD.obs.observe(document.documentElement, { subtree: true, childList: true, attributes: true, attributeFilter: ['open', 'class'] });
    } catch (e) {}
  }
  function guardRelease() {
    if (!GUARD.on) return;
    GUARD.on = false;
    document.documentElement.classList.remove('kh-up-lock');
    if (GUARD.orig && window.HTMLDialogElement) HTMLDialogElement.prototype.showModal = GUARD.orig;
    GUARD.orig = null;
    if (GUARD.obs) { try { GUARD.obs.disconnect(); } catch (e) {} }
    GUARD.obs = null;
  }

  /* ---------- helpers ---------- */
  function money(cents) {
    var n = (Math.round(cents) / 100).toFixed(2);
    return '$' + n.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }
  function off(cents, p) { return cents - Math.floor(cents * p / 100); }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }

  var cart = null;
  function refreshCart() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (c) { cart = c; return c; })
      .catch(function () { return null; });
  }
  refreshCart();
  document.addEventListener('cart:update', function () { refreshCart(); });
  function cartQty(vid) {
    if (!cart || !cart.items) return 0;
    var q = 0;
    for (var i = 0; i < cart.items.length; i++) if (String(cart.items[i].id) === String(vid)) q += cart.items[i].quantity;
    return q;
  }
  function postJSON(url, body) {
    return fetch(url, {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) { if (!r.ok) throw new Error(url + ' ' + r.status); return r.json(); });
  }

  function findVariant(id) {
    id = String(id);
    for (var i = 0; i < CFG.products.length; i++) {
      var p = CFG.products[i];
      for (var j = 0; j < p.variants.length; j++) if (String(p.variants[j].id) === id) return { product: p, variant: p.variants[j] };
    }
    return null;
  }
  function isAvail(v) { return !!v.available; }
  function byGrams(a, b) { return a.grams - b.grams; }

  /* Every in-stock size LARGER than the tin added, smallest first. */
  function upsizeOptions(p, v) {
    return p.variants.filter(function (x) { return isAvail(x) && x.grams > v.grams; }).sort(byGrams);
  }
  /* Every in-stock size of the other caviar that is the same size or larger.
     Fallback when the other caviar is out: a second tin of the same caviar, same size or larger. */
  function pairOptions(p, v) {
    var c = [];
    CFG.products.forEach(function (q) {
      if (q === p) return;
      q.variants.forEach(function (x) { if (isAvail(x) && x.grams >= v.grams) c.push({ product: q, variant: x, second: false }); });
    });
    if (!c.length) {
      p.variants.forEach(function (x) { if (isAvail(x) && x.grams >= v.grams) c.push({ product: p, variant: x, second: true }); });
    }
    c.sort(function (a, b) { return byGrams(a.variant, b.variant); });
    return c;
  }
  /* Default pair: the listed size with the most units in stock (ties go to the bigger tin). */
  function defaultPair(list) {
    var best = null;
    list.forEach(function (o) {
      if (!best || o.variant.stock > best.variant.stock || (o.variant.stock === best.variant.stock && o.variant.grams > best.variant.grams)) best = o;
    });
    return best;
  }
  function toolsOffer() {
    var t = CFG.tools;
    if (!t || !t.spoonAvailable || !t.openerAvailable) return null;
    if (cartQty(t.spoonId) > 0 && cartQty(t.openerId) > 0) return null;
    return t;
  }

  /* Live availability check before anything is offered. Never blocks for more than 1.5s. */
  function liveCheck() {
    var handles = CFG.products.map(function (p) { return p.handle; });
    if (CFG.tools) handles = handles.concat([CFG.tools.spoonHandle, CFG.tools.openerHandle]);
    var jobs = handles.map(function (h) {
      return fetch('/products/' + h + '.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (pj) {
          if (!pj || !pj.variants) return;
          var p = null;
          for (var i = 0; i < CFG.products.length; i++) if (CFG.products[i].handle === h) p = CFG.products[i];
          pj.variants.forEach(function (lv) {
            if (p) {
              for (var j = 0; j < p.variants.length; j++) {
                if (String(p.variants[j].id) === String(lv.id)) {
                  p.variants[j].available = !!lv.available;
                  if (!lv.available) p.variants[j].stock = 0;
                }
              }
            } else if (CFG.tools) {
              if (String(lv.id) === String(CFG.tools.spoonId)) CFG.tools.spoonAvailable = !!lv.available;
              if (String(lv.id) === String(CFG.tools.openerId)) CFG.tools.openerAvailable = !!lv.available;
            }
          });
        })
        .catch(function () {});
    });
    return Promise.race([Promise.all(jobs), new Promise(function (res) { setTimeout(res, 1500); })]);
  }

  /* ---------- trigger detection ---------- */
  var BUYNOW_SELECTORS = ['[data-kh-hyb-buy]', '[data-kh-buynow]', '.shopify-payment-button__button', '[data-shopify="payment-button"]'];
  var ATC_SELECTORS = ['[data-kh-atc]', 'add-to-cart-component button', 'button[name="add"]', 'form[action*="/cart/add"] button[type="submit"]'];

  function closestMatch(el, selectors) {
    if (!el || !el.closest) return null;
    for (var i = 0; i < selectors.length; i++) { var hit = el.closest(selectors[i]); if (hit) return hit; }
    return null;
  }
  function variantForTrigger(trigger) {
    var explicit = trigger.getAttribute && trigger.getAttribute('data-kh-vid');
    if (explicit) return findVariant(explicit);
    var group = trigger.closest ? trigger.closest('[data-kh-buy]') : null;
    if (group) {
      var pill = group.querySelector('.kh-buy__opt[aria-checked="true"]');
      if (pill) return findVariant(pill.getAttribute('data-vid'));
    }
    var form = trigger.closest ? trigger.closest('form') : null;
    var idInput = form && form.querySelector('[name="id"]');
    if (idInput && idInput.value) return findVariant(idInput.value);
    var host = trigger.closest ? trigger.closest('add-to-cart-component, product-form-component, [data-product-id]') : null;
    if (host) {
      var nested = host.querySelector('[name="id"]');
      if (nested && nested.value) return findVariant(nested.value);
    }
    var anyForm = document.querySelector('form[action*="/cart/add"] [name="id"]');
    if (anyForm && anyForm.value) return findVariant(anyForm.value);
    return null;
  }
  function qtyForTrigger(trigger) {
    var form = trigger.closest ? trigger.closest('form') : null;
    var q = form && form.querySelector('[name="quantity"]');
    if (!q) {
      var host = trigger.closest ? trigger.closest('product-form-component, add-to-cart-component, [data-kh-buy]') : null;
      q = host && host.querySelector('[name="quantity"]');
    }
    var n = q ? parseInt(q.value, 10) : 1;
    return n > 0 ? n : 1;
  }

  /* ---------- styles ---------- */
  function styleOnce() {
    if (document.getElementById('kh-up-style')) return;
    var s = document.createElement('style');
    s.id = 'kh-up-style';
    s.textContent = [
      'html.kh-up-lock dialog[open]:not(.kh-up),html.kh-up-lock cart-drawer-component,html.kh-up-lock [data-cart-drawer],html.kh-up-lock .cart-drawer,html.kh-up-lock .drawer--cart{display:none !important}',
      'html.kh-up-lock{overflow:hidden !important}',
      'dialog.kh-up{position:fixed;inset:0;margin:0;padding:16px;border:0;box-sizing:border-box;width:100%;max-width:100%;height:100%;max-height:100%;background:transparent;overflow:hidden;place-items:center;font-family:Montserrat,Arial,Helvetica,sans-serif;z-index:2147483000;}',
      'dialog.kh-up[open]{display:grid}dialog.kh-up:not([open]){display:none}',
      'dialog.kh-up::backdrop{background:rgba(4,4,6,.86);-webkit-backdrop-filter:blur(3px);backdrop-filter:blur(3px)}',
      '.kh-up__panel{position:relative;display:flex;flex-direction:column;width:min(600px,100%);max-height:calc(100vh - 32px);max-height:calc(100dvh - 32px);box-sizing:border-box;background:linear-gradient(180deg,#101016,#0a0a0c);border:1px solid rgba(201,163,92,.42);border-radius:14px;color:#cfcabf;box-shadow:0 30px 80px -20px rgba(0,0,0,.9);animation:khUpRise .22s cubic-bezier(.2,.7,.3,1)}',
      '@keyframes khUpRise{from{opacity:0;transform:translateY(14px) scale(.98)}to{opacity:1;transform:none}}',
      '.kh-up__body{flex:1 1 auto;overflow-y:auto;overscroll-behavior:contain;-webkit-overflow-scrolling:touch;padding:24px 24px 6px}',
      '.kh-up__foot{flex:0 0 auto;padding:12px 24px 18px;padding-bottom:max(18px,env(safe-area-inset-bottom));border-top:1px solid rgba(201,163,92,.18);background:#0a0a0c;border-radius:0 0 14px 14px}',
      '.kh-up__x{position:absolute;top:8px;right:8px;width:44px;height:44px;border:0;border-radius:50%;background:rgba(0,0,0,.45);cursor:pointer;z-index:2}',
      '.kh-up__x::before,.kh-up__x::after{content:"";position:absolute;top:50%;left:50%;width:14px;height:1.6px;border-radius:2px;background:#b8b3aa}',
      '.kh-up__x::before{transform:translate(-50%,-50%) rotate(45deg)}.kh-up__x::after{transform:translate(-50%,-50%) rotate(-45deg)}',
      '.kh-up__x:hover::before,.kh-up__x:hover::after{background:#e7d3a1}',
      '.kh-up__flag{display:inline-flex;align-items:center;gap:7px;margin:0 0 10px;font-size:9px;font-weight:700;letter-spacing:2.2px;text-transform:uppercase;color:#0a0a0c;background:linear-gradient(100deg,#e7d3a1,#c9a35c);border-radius:3px;padding:5px 10px}',
      '.kh-up__dot{width:5px;height:5px;border-radius:50%;background:#0a0a0c;animation:khUpPulse 1.6s ease-in-out infinite}',
      '@keyframes khUpPulse{0%,100%{opacity:1}50%{opacity:.25}}',
      '.kh-up__title{margin:0 0 6px;font-family:"Tenor Sans",Georgia,serif;font-size:26px;line-height:1.14;font-weight:400;color:#f3efe6}',
      '.kh-up__lead{margin:0 0 14px;font-size:12.5px;line-height:1.55;color:#a9a49a}.kh-up__lead b{color:#e7d3a1}',
      '.kh-up__opts{display:grid;gap:9px;margin-bottom:14px}',
      '.kh-up__opt{position:relative;display:grid;grid-template-columns:22px 70px minmax(0,1fr);gap:12px;align-items:start;cursor:pointer;border:1px solid rgba(201,163,92,.3);border-radius:10px;background:rgba(255,255,255,.02);padding:12px;min-height:44px;transition:border-color .2s,background-color .2s;-webkit-tap-highlight-color:transparent}',
      '.kh-up__opt:hover{border-color:#c9a35c;background:rgba(201,163,92,.07)}',
      '.kh-up__opt.is-on{border-color:#c9a35c;background:rgba(201,163,92,.12);box-shadow:0 0 0 1px #c9a35c inset}',
      '.kh-up__check{position:absolute;opacity:0;width:1px;height:1px;margin:0;pointer-events:none}',
      '.kh-up__box{width:22px;height:22px;border:1px solid rgba(201,163,92,.6);border-radius:5px;position:relative;background:rgba(0,0,0,.3);margin-top:24px}',
      '.kh-up__opt.is-on .kh-up__box{background:linear-gradient(100deg,#e7d3a1,#c9a35c);border-color:#e7d3a1}',
      '.kh-up__opt.is-on .kh-up__box::after{content:"";position:absolute;left:7px;top:3px;width:5px;height:10px;border:solid #0a0a0c;border-width:0 2px 2px 0;transform:rotate(45deg)}',
      '.kh-up__img{position:relative;display:grid;place-items:center;aspect-ratio:1/1;border-radius:8px;overflow:hidden;background:#0a0a0c}',
      '.kh-up__img img{width:100%;height:100%;object-fit:contain;display:block}',
      '.kh-up__img--pair{grid-template-columns:1fr 1fr;gap:2px;padding:4px}.kh-up__img--pair img{height:auto}',
      '.kh-up__pct{position:absolute;top:3px;left:3px;background:linear-gradient(100deg,#e7d3a1,#c9a35c);color:#0a0a0c;font-size:9px;font-weight:700;border-radius:3px;padding:1px 5px}',
      '.kh-up__text{display:grid;gap:4px;min-width:0}',
      '.kh-up__name{font-size:13px;font-weight:700;color:#f3efe6;line-height:1.35}',
      '.kh-up__desc{font-size:11.5px;line-height:1.45;color:#8f8b83}',
      '.kh-up__sizes{display:flex;flex-wrap:wrap;gap:6px;margin-top:4px}',
      '.kh-up__pill{appearance:none;display:inline-flex;align-items:baseline;gap:5px;min-height:34px;padding:0 11px;border-radius:999px;border:1px solid rgba(201,163,92,.4);background:rgba(255,255,255,.03);color:#cfcabf;font-family:inherit;font-size:12px;font-weight:600;cursor:pointer;-webkit-tap-highlight-color:transparent}',
      '.kh-up__pill i{font-style:normal;font-weight:400;font-size:11px;color:#a9a49a}',
      '.kh-up__pill[aria-checked="true"]{background:linear-gradient(100deg,#e7d3a1,#c9a35c);border-color:#e7d3a1;color:#0a0a0c}.kh-up__pill[aria-checked="true"] i{color:#0a0a0c}',
      '.kh-up__prices{display:flex;align-items:baseline;flex-wrap:wrap;gap:7px;margin-top:2px}',
      '.kh-up__prices s{font-size:11.5px;color:#7e7a73}.kh-up__prices b{font-size:16px;color:#e7d3a1}',
      '.kh-up__save{background:#e7d3a1;color:#0a0a0c;font-size:9px;font-weight:700;letter-spacing:.8px;text-transform:uppercase;border-radius:3px;padding:3px 7px}',
      '.kh-up__sum{border:1px solid rgba(201,163,92,.28);border-radius:10px;padding:12px 14px;background:rgba(255,255,255,.02);margin-bottom:6px}',
      '.kh-up__line{display:flex;justify-content:space-between;gap:10px;font-size:12px;color:#a9a49a;padding:3px 0}',
      '.kh-up__line span:last-child{white-space:nowrap}.kh-up__line s{color:#6d6a64;margin-right:6px}.kh-up__line b{color:#f3efe6;font-weight:600}',
      '.kh-up__tot{display:flex;justify-content:space-between;gap:10px;padding:5px 0 0;margin-top:6px;border-top:1px solid rgba(201,163,92,.18);font-size:12.5px;color:#cfcabf}',
      '.kh-up__tot b{color:#f3efe6;font-size:15px}.kh-up__tot--save{color:#e7d3a1}.kh-up__tot--save b{color:#e7d3a1}',
      '.kh-up__fine{margin:8px 0 0;font-size:10.5px;line-height:1.5;color:#6d6a64}',
      '.kh-up__go{display:block;width:100%;box-sizing:border-box;min-height:54px;border:1px solid #c9a35c;border-radius:7px;cursor:pointer;background:linear-gradient(100deg,#e7d3a1,#c9a35c);color:#0a0a0c;font-family:inherit;font-size:12px;font-weight:700;letter-spacing:2px;text-transform:uppercase}',
      '.kh-up__go:hover{opacity:.92;box-shadow:0 0 18px -4px rgba(231,211,161,.6)}.kh-up__go[disabled]{opacity:.55;cursor:default}',
      '.kh-up__no{display:block;width:100%;margin-top:8px;background:none;border:0;cursor:pointer;color:#8f8b83;font-family:inherit;font-size:11px;letter-spacing:1.4px;text-transform:uppercase;padding:10px;min-height:44px}',
      '.kh-up__no:hover{color:#cfcabf;text-decoration:underline}',
      '.kh-up *:focus-visible{outline:2px solid #e7d3a1;outline-offset:2px}',
      '@media screen and (max-width:600px){dialog.kh-up{padding:0;place-items:end center}.kh-up__panel{width:100%;max-height:calc(100vh - 12px);max-height:calc(100dvh - 12px);border-radius:16px 16px 0 0;border-bottom:0}',
      '.kh-up__body{padding:18px 15px 4px}.kh-up__foot{padding:10px 15px 14px;padding-bottom:max(14px,env(safe-area-inset-bottom));border-radius:0}',
      '.kh-up__title{font-size:21px}.kh-up__lead{margin-bottom:10px;font-size:12px}.kh-up__opt{grid-template-columns:20px 54px minmax(0,1fr);gap:9px;padding:10px}.kh-up__box{margin-top:16px}',
      '.kh-up__name{font-size:12px}.kh-up__prices b{font-size:14px}.kh-up__go{min-height:52px}.kh-up__pill{min-height:32px;padding:0 9px;font-size:11.5px}}',
      '@media screen and (max-height:480px){.kh-up__body{padding-top:12px}.kh-up__title{font-size:19px;margin-bottom:4px}.kh-up__lead{margin-bottom:8px}.kh-up__flag{margin-bottom:6px}}',
      '@media (prefers-reduced-motion:reduce){.kh-up__panel{animation:none}.kh-up__dot{animation:none}}'
    ].join('');
    document.head.appendChild(s);
  }

  /* ---------- dialog ---------- */
  function optRow(key, imgHtml, name, desc, pillsHtml) {
    return '<label class="kh-up__opt" data-kh-up-opt="' + key + '">' +
      '<input type="checkbox" class="kh-up__check" data-kh-up-check="' + key + '">' +
      '<span class="kh-up__box" aria-hidden="true"></span>' +
      imgHtml +
      '<span class="kh-up__text">' +
        '<b class="kh-up__name" data-kh-up-name="' + key + '">' + name + '</b>' +
        '<span class="kh-up__desc" data-kh-up-desc="' + key + '">' + desc + '</span>' +
        (pillsHtml ? '<span class="kh-up__sizes" role="radiogroup" aria-label="Tin size" data-kh-up-sizes="' + key + '">' + pillsHtml + '</span>' : '') +
        '<span class="kh-up__prices" data-kh-up-prices="' + key + '"></span>' +
      '</span>' +
    '</label>';
  }
  function img1(src, badge) {
    return '<span class="kh-up__img">' + (src ? '<img src="' + esc(src) + '" alt="" loading="lazy" width="140" height="140">' : '') + (badge ? '<b class="kh-up__pct" data-kh-up-badge="' + badge + '"></b>' : '') + '</span>';
  }
  function pillsFor(key, list, selectedId) {
    return list.map(function (o) {
      var v = o.variant || o;
      return '<button type="button" class="kh-up__pill" role="radio" data-kh-up-pill="' + key + '" data-vid="' + v.id + '" aria-checked="' + (String(v.id) === String(selectedId) ? 'true' : 'false') + '">' + esc(v.size) + ' <i data-kh-up-pillprice="' + v.id + '"></i></button>';
    }).join('');
  }

  function buildDialog(ctx, mode) {
    var p = ctx.product, v = ctx.variant, ups = ctx.upOptions, pairs = ctx.pairOptions, tools = ctx.tools;
    if (!ups.length && !pairs.length && !tools) return null;

    var dlg = document.createElement('dialog');
    dlg.className = 'kh-up';
    dlg.setAttribute('aria-label', 'Add to your ' + p.name + ' ' + v.size);

    var rows = '';
    if (ups.length) rows += optRow('up', img1(p.img, 'up'), 'Upsize your ' + esc(p.name), 'Pick a bigger tin instead of the ' + esc(v.size) + '.', pillsFor('up', ups, ctx.up.id));
    if (pairs.length) {
      var first = ctx.pair;
      var pn = first.second ? 'Add a second tin of ' + esc(p.name) : 'Pair it with ' + esc(first.product.name);
      var pd = first.second ? 'Two tins, one delivery.' : 'Both caviars, one delivery.';
      rows += optRow('pair', img1(first.product.img, 'pair'), pn, pd, pillsFor('pair', pairs, first.variant.id));
    }
    if (tools) {
      var timg = '<span class="kh-up__img kh-up__img--pair">' +
        (tools.spoonImg ? '<img src="' + esc(tools.spoonImg) + '" alt="" loading="lazy" width="70" height="70">' : '') +
        (tools.openerImg ? '<img src="' + esc(tools.openerImg) + '" alt="" loading="lazy" width="70" height="70">' : '') + '</span>';
      rows += optRow('tools', timg, 'Add the mother-of-pearl spoon and tin opener', 'Nacre never taints the roe the way metal does.', '');
    }

    var flag = mode === 'buynow' ? 'Before you check out' : 'Added to cart';
    var declineLabel = mode === 'buynow' ? 'No thanks, continue to checkout' : 'No thanks';
    var tierLine = (ups.length && pairs.length)
      ? 'Tick one and save <b>' + CFG.pct.one + '%</b>. Tick both and save <b>' + CFG.pct.both + '%</b> on both tins.'
      : (ups.length || pairs.length) ? 'Tick it and save <b>' + CFG.pct.one + '%</b>.' : 'Serve it properly.';

    dlg.innerHTML =
      '<div class="kh-up__panel" role="document">' +
        '<button type="button" class="kh-up__x" data-kh-up-dismiss aria-label="Close"></button>' +
        '<div class="kh-up__body">' +
          '<p class="kh-up__flag"><span class="kh-up__dot" aria-hidden="true"></span>' + flag + '</p>' +
          '<h2 class="kh-up__title">Make more of your ' + esc(p.name) + '</h2>' +
          '<p class="kh-up__lead">Your ' + esc(p.name) + ' ' + esc(v.size) + ' is <b>' + money(v.price * ctx.qty) + '</b>. ' + tierLine + '</p>' +
          '<div class="kh-up__opts">' + rows + '</div>' +
          '<div class="kh-up__sum" data-kh-up-sum aria-live="polite"></div>' +
          '<p class="kh-up__fine">Prices include GST. Every saving is applied by Shopify at checkout and stays only while the ticked items stay in your cart.</p>' +
        '</div>' +
        '<div class="kh-up__foot">' +
          '<button type="button" class="kh-up__go" data-kh-up-go>Add to my order</button>' +
          '<button type="button" class="kh-up__no" data-kh-up-dismiss>' + declineLabel + '</button>' +
        '</div>' +
      '</div>';
    return dlg;
  }

  function closeCartDrawer(mine) {
    var comps = document.querySelectorAll('cart-drawer-component');
    for (var c = 0; c < comps.length; c++) { try { if (typeof comps[c].close === 'function') comps[c].close(); } catch (e) {} }
    var open = document.querySelectorAll('dialog[open]');
    for (var i = 0; i < open.length; i++) {
      var d = open[i];
      if (d === mine) continue;
      var tag = (d.id || '') + ' ' + (d.className || '');
      if (/cart|drawer/i.test(tag) || (d.closest && d.closest('cart-drawer-component, [data-cart-drawer]'))) { try { d.close(); } catch (e) {} }
    }
  }
  function openCartDrawer() {
    try {
      var comp = document.querySelector('cart-drawer-component');
      if (comp && typeof comp.open === 'function') { comp.open(); return true; }
    } catch (e) {}
    return false;
  }

  function close(dlg) {
    if (!dlg) return;
    guardRelease();
    try { if (dlg.open) dlg.close(); } catch (e) {}
    if (dlg.parentNode) dlg.parentNode.removeChild(dlg);
    unlockScroll();
    if (openNow === dlg) openNow = null;
  }

  function proceed(trigger, mode, ctx) {
    if (mode === 'buynow' && trigger) {
      if (trigger.hasAttribute && trigger.hasAttribute('data-kh-hyb-buy')) {
        if (ctx && cartQty(ctx.variant.id) < 1) {
          postJSON('/cart/add.js', { items: [{ id: Number(ctx.variant.id), quantity: 1 }] })
            .then(function () { window.location.href = '/checkout'; })
            .catch(function () { window.location.href = trigger.getAttribute('href') || '/checkout'; });
          return;
        }
        window.location.href = '/checkout';
        return;
      }
      BYPASS = true;
      try { trigger.click(); } finally { setTimeout(function () { BYPASS = false; }, 0); }
      return;
    }
    if (mode === 'own') {
      refreshCart().then(function () {
        document.dispatchEvent(new CustomEvent('cart:update', { bubbles: true, detail: { data: { itemCount: cart ? cart.item_count : 0 } } }));
        if (!openCartDrawer()) window.location.href = '/cart';
      });
      return;
    }
    refreshCart().then(function () {
      document.dispatchEvent(new CustomEvent('cart:update', { bubbles: true, detail: { data: { itemCount: cart ? cart.item_count : 0 } } }));
      openCartDrawer();
    });
  }

  /* Wait for the theme's own add to land before touching the cart. */
  function ensureInCart(vid, wantQty) {
    var tries = 0;
    return new Promise(function (resolve) {
      (function poll() {
        refreshCart().then(function () {
          if (cartQty(vid) >= wantQty || tries++ > 12) resolve();
          else setTimeout(poll, 350);
        });
      })();
    });
  }

  function show(ctx, trigger, mode) {
    styleOnce();
    var dlg = buildDialog(ctx, mode);
    if (!dlg) return false;

    document.body.appendChild(dlg);
    openNow = dlg;
    guardEngage();
    closeCartDrawer(dlg);
    lockScroll();
    try { dlg.showModal(); } catch (e) {
      dlg.setAttribute('open', '');
      dlg.style.position = 'fixed'; dlg.style.zIndex = '2147483000'; dlg.style.background = 'rgba(4,4,6,.86)';
    }
    setTimeout(function () { if (openNow === dlg) { closeCartDrawer(dlg); shutOthers(); } }, 300);
    setTimeout(function () { if (openNow === dlg) { closeCartDrawer(dlg); shutOthers(); } }, 1000);
    setTimeout(function () { if (openNow === dlg) { closeCartDrawer(dlg); shutOthers(); } }, 2500);

    var p = ctx.product, v = ctx.variant, tools = ctx.tools, qty = ctx.qty;
    var go = dlg.querySelector('[data-kh-up-go]');
    var sum = dlg.querySelector('[data-kh-up-sum]');
    var checks = {};
    Array.prototype.forEach.call(dlg.querySelectorAll('[data-kh-up-check]'), function (c) { checks[c.getAttribute('data-kh-up-check')] = c; });
    function on(key) { return !!(checks[key] && checks[key].checked); }
    function setPrices(key, list, offer, save) {
      var el = dlg.querySelector('[data-kh-up-prices="' + key + '"]');
      if (!el) return;
      el.innerHTML = (save > 0 ? '<s>' + money(list) + '</s>' : '') + '<b>' + money(offer) + '</b>' + (save > 0 ? '<span class="kh-up__save">Save ' + money(save) + '</span>' : '');
      var badge = dlg.querySelector('[data-kh-up-badge="' + key + '"]');
      if (badge) { badge.textContent = save > 0 ? '-' + Math.round(save * 100 / list) + '%' : ''; badge.style.display = save > 0 ? '' : 'none'; }
    }
    function setPill(key, vid) {
      Array.prototype.forEach.call(dlg.querySelectorAll('[data-kh-up-pill="' + key + '"]'), function (b) {
        b.setAttribute('aria-checked', String(b.getAttribute('data-vid')) === String(vid) ? 'true' : 'false');
      });
    }

    function sync() {
      var selUp = on('up') && !!ctx.up, selPair = on('pair') && !!ctx.pair, selTools = on('tools') && !!tools;
      var tier = (selUp && selPair) ? CFG.pct.both : (selUp || selPair) ? CFG.pct.one : 0;
      var lines = [], value = 0, pay = 0;

      var tin = selUp ? ctx.up : v;
      var tinList = tin.price * qty;
      var tinPct = (selUp || selPair) ? tier : 0;
      var tinPay = off(tinList, tinPct);
      lines.push({ n: p.name + ' ' + tin.size + (qty > 1 ? ' x ' + qty : ''), list: tinList, pay: tinPay });
      value += tinList; pay += tinPay;

      if (ctx.pair) {
        var pv = ctx.pair.variant, pList = pv.price;
        var pairPct = selPair ? tier : (selUp ? CFG.pct.both : CFG.pct.one);
        var pPay = off(pList, pairPct);
        if (selPair) { lines.push({ n: ctx.pair.product.name + ' ' + pv.size, list: pList, pay: pPay }); value += pList; pay += pPay; }
        setPrices('pair', pList, pPay, pList - pPay);
        Array.prototype.forEach.call(dlg.querySelectorAll('[data-kh-up-pill="pair"]'), function (b) {
          var o = ctx.pairOptions.filter(function (x) { return String(x.variant.id) === b.getAttribute('data-vid'); })[0];
          var pp = b.querySelector('[data-kh-up-pillprice]');
          if (o && pp) pp.textContent = money(off(o.variant.price, pairPct));
        });
        var pd = dlg.querySelector('[data-kh-up-desc="pair"]');
        if (pd) pd.textContent = (ctx.pair.second ? 'Two tins, one delivery. ' : 'Both caviars, one delivery. ') + pairPct + '% off both tins' + (ctx.pair.second ? '' : ', including your ' + p.name) + '.';
      }
      if (ctx.up) {
        var uList = ctx.up.price * qty;
        var uPct = selUp ? tier : (selPair ? CFG.pct.both : CFG.pct.one);
        var uPay = off(uList, uPct);
        setPrices('up', uList, uPay, uList - uPay);
        Array.prototype.forEach.call(dlg.querySelectorAll('[data-kh-up-pill="up"]'), function (b) {
          var o = ctx.upOptions.filter(function (x) { return String(x.id) === b.getAttribute('data-vid'); })[0];
          var pp = b.querySelector('[data-kh-up-pillprice]');
          if (o && pp) pp.textContent = money(off(o.price * qty, uPct));
        });
        var ud = dlg.querySelector('[data-kh-up-desc="up"]');
        if (ud) ud.textContent = ctx.up.grams + 'g instead of ' + v.grams + 'g. Only ' + money(uPay - off(v.price * qty, selPair ? tier : 0)) + ' more than the ' + v.size + ' for ' + (ctx.up.grams - v.grams) + 'g extra.';
      }
      if (tools) {
        var tVal = tools.spoonPrice + tools.openerPrice;
        setPrices('tools', tVal, tools.pairPrice, tVal - tools.pairPrice);
        if (selTools) { lines.push({ n: 'Spoon and tin opener', list: tVal, pay: tools.pairPrice }); value += tVal; pay += tools.pairPrice; }
      }

      Object.keys(checks).forEach(function (k) {
        var opt = dlg.querySelector('[data-kh-up-opt="' + k + '"]');
        if (opt) opt.classList.toggle('is-on', checks[k].checked);
      });

      var html = '';
      lines.forEach(function (l) {
        html += '<div class="kh-up__line"><span>' + esc(l.n) + '</span><span>' + (l.pay < l.list ? '<s>' + money(l.list) + '</s>' : '') + '<b>' + money(l.pay) + '</b></span></div>';
      });
      html += '<div class="kh-up__tot"><span>Total value</span><span><s>' + money(value) + '</s></span></div>';
      html += '<div class="kh-up__tot"><span>You pay</span><b>' + money(pay) + '</b></div>';
      html += '<div class="kh-up__tot kh-up__tot--save"><span>You save</span><b>' + money(value - pay) + '</b></div>';
      var note = '';
      if (selUp && selPair) note = CFG.pct.both + '% off both tins, applied at checkout with code ' + CFG.codes.both + '.';
      else if (selUp) note = CFG.pct.one + '% off your upsized tin, applied at checkout with code ' + CFG.codes.upsize + '.';
      else if (selPair) note = CFG.pct.one + '% off both tins, applied at checkout with code ' + CFG.codes.pair + '.';
      if (selTools) note += (note ? ' ' : '') + 'Spoon and opener ring up at $19.95 the pair automatically.';
      if (!selUp && !selPair && !selTools) note = 'Nothing ticked yet. Tick an offer to see your saving.';
      html += '<p class="kh-up__fine" style="margin-top:6px;color:#a9a49a">' + esc(note) + '</p>';
      sum.innerHTML = html;

      var n = (selUp ? 1 : 0) + (selPair ? 1 : 0) + (selTools ? 1 : 0);
      go.textContent = n === 0 ? (mode === 'buynow' ? 'Continue to checkout' : 'Continue without') : (mode === 'buynow' ? 'Add and check out' : 'Add to my order');
    }

    Object.keys(checks).forEach(function (k) { checks[k].addEventListener('change', sync); });

    /* Size pills: choosing a size also ticks the row. */
    dlg.addEventListener('click', function (e) {
      var pill = e.target.closest && e.target.closest('[data-kh-up-pill]');
      if (!pill) return;
      e.preventDefault();
      var key = pill.getAttribute('data-kh-up-pill'), vid = pill.getAttribute('data-vid');
      if (key === 'up') {
        var u = ctx.upOptions.filter(function (x) { return String(x.id) === String(vid); })[0];
        if (u) ctx.up = u;
      } else if (key === 'pair') {
        var o = ctx.pairOptions.filter(function (x) { return String(x.variant.id) === String(vid); })[0];
        if (o) ctx.pair = o;
      }
      setPill(key, vid);
      if (checks[key] && !checks[key].checked) checks[key].checked = true;
      sync();
    });

    sync();

    /* dismiss: X, No thanks, Escape, backdrop */
    dlg.addEventListener('click', function (e) {
      if (e.target === dlg) { e.preventDefault(); close(dlg); proceed(trigger, mode, ctx); return; }
      if (e.target.closest && e.target.closest('[data-kh-up-dismiss]')) { e.preventDefault(); close(dlg); proceed(trigger, mode, ctx); }
    });
    dlg.addEventListener('cancel', function (e) { e.preventDefault(); close(dlg); proceed(trigger, mode, ctx); });

    go.addEventListener('click', function () {
      var selUp = on('up') && !!ctx.up, selPair = on('pair') && !!ctx.pair, selTools = on('tools') && !!tools;
      if (!selUp && !selPair && !selTools) { close(dlg); proceed(trigger, mode, ctx); return; }
      go.disabled = true;
      go.textContent = 'Adding...';
      BYPASS = true;
      var up = ctx.up, pair = ctx.pair;
      var chain = Promise.resolve();
      if (mode === 'buynow') {
        chain = chain.then(function () { return refreshCart(); }).then(function () {
          if (cartQty(v.id) < 1) return postJSON('/cart/add.js', { items: [{ id: Number(v.id), quantity: qty }] });
        });
      } else if (mode === 'own') {
        chain = chain.then(function () { return refreshCart(); });
      } else {
        chain = chain.then(function () { return ensureInCart(v.id, ctx.before + qty); });
      }
      if (selUp) {
        chain = chain.then(function () { return refreshCart(); }).then(function () {
          var updates = {};
          updates[String(v.id)] = Math.max(0, cartQty(v.id) - qty);
          updates[String(up.id)] = cartQty(up.id) + qty;
          return postJSON('/cart/update.js', { updates: updates });
        });
      }
      var items = [];
      if (selPair) items.push({ id: Number(pair.variant.id), quantity: 1 });
      if (selTools) { if (cartQty(tools.spoonId) < 1) items.push({ id: Number(tools.spoonId), quantity: 1 }); if (cartQty(tools.openerId) < 1) items.push({ id: Number(tools.openerId), quantity: 1 }); }
      if (items.length) chain = chain.then(function () { return postJSON('/cart/add.js', { items: items }); });
      var code = (selUp && selPair) ? CFG.codes.both : selUp ? CFG.codes.upsize : selPair ? CFG.codes.pair : '';
      if (code) chain = chain.then(function () { return postJSON('/cart/update.js', { discount: code }).catch(function () {}); });
      chain.then(function () {
        close(dlg);
        var dest = mode === 'buynow' ? '/checkout' : '/cart';
        window.location.href = code ? '/discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent(dest) : dest;
      }).catch(function () {
        close(dlg);
        window.location.href = '/cart';
      });
    });

    try { go.focus({ preventScroll: true }); } catch (e) {}
    return true;
  }

  function contextFor(hit, trigger) {
    var p = hit.product, v = hit.variant;
    var ups = upsizeOptions(p, v);
    var pairs = pairOptions(p, v);
    return {
      product: p, variant: v, qty: qtyForTrigger(trigger),
      upOptions: ups, up: ups[0] || null,
      pairOptions: pairs, pair: defaultPair(pairs),
      tools: toolsOffer(), before: cartQty(v.id)
    };
  }

  document.addEventListener('click', function (e) {
    if (BYPASS || openNow) return;
    if (e.defaultPrevented) return;
    if (e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    var el = e.target;
    if (!el || !el.closest) return;

    var buyTrigger = closestMatch(el, BUYNOW_SELECTORS);
    var atcTrigger = buyTrigger ? null : closestMatch(el, ATC_SELECTORS);
    if (!buyTrigger && !atcTrigger) return;
    var trigger = buyTrigger || atcTrigger;
    if (trigger.disabled) return;

    var hit = variantForTrigger(trigger);
    if (!hit) return;

    if (buyTrigger) {
      e.preventDefault();
      e.stopImmediatePropagation();
      liveCheck().then(function () {
        var ctx = contextFor(hit, trigger);
        if (!show(ctx, trigger, 'buynow')) proceed(trigger, 'buynow', ctx);
      });
      return;
    }

    /* Plain forms (no theme component) would navigate away, so do the add here. */
    var themed = trigger.closest('product-form-component, add-to-cart-component, [data-kh-buy], quick-add-component');
    if (!themed) {
      var form = trigger.closest('form');
      if (form && /\/cart\/add/.test(form.getAttribute('action') || '')) {
        e.preventDefault();
        e.stopImmediatePropagation();
        var ctxOwn = contextFor(hit, trigger);
        postJSON('/cart/add.js', { items: [{ id: Number(hit.variant.id), quantity: ctxOwn.qty }] })
          .then(function () { return liveCheck(); })
          .then(function () {
            ctxOwn = contextFor(hit, trigger);
            if (!show(ctxOwn, trigger, 'own')) proceed(trigger, 'own', ctxOwn);
          })
          .catch(function () { form.submit(); });
        return;
      }
    }

    /* Theme add to cart: never cancelled. The tin lands while the offer is already up. */
    var ctx0 = contextFor(hit, trigger);
    liveCheck().then(function () {
      if (openNow) return;
      var ctx = contextFor(hit, trigger);
      ctx.before = ctx0.before;
      show(ctx, null, 'atc');
    });
  }, true);
})();